import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import PropTypes from "prop-types"

function StatsCard({ title, value, icon: Icon, className }) {
  return (
    <Card className={`overflow-hidden ${className}`}>
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <CardTitle className="text-sm sm:text-base font-medium">
          {title}
        </CardTitle>
        {Icon && (
          <Icon className="h-4 w-4 sm:h-5 sm:w-5 text-muted-foreground opacity-75" />
        )}
      </CardHeader>
      <CardContent>
        <div className="text-xl sm:text-2xl lg:text-3xl font-bold tracking-tight">
          {value}
        </div>
      </CardContent>
    </Card>
  )
}

StatsCard.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  icon: PropTypes.elementType,
  className: PropTypes.string,
}

export default StatsCard
